import { render } from "./AccountingPurchaseView.vue?vue&type=template&id=363e111b"
import script from "./AccountingPurchaseView.vue?vue&type=script&lang=js"
export * from "./AccountingPurchaseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__